import createAxios from "./httpCommon";

export const fetchDeliveryStates = async () => {
  try {
    const axios = await createAxios();
    const response = await axios.get("/location/state/user");
    return response?.data || [];
  } catch (error) {
    throw error;
  }
};

export const fetchDeliveryLGAs = async (stateId) => {
  const axios = await createAxios();
  const response = await axios.get(`/location/state/${stateId}/lga`);
  return (response?.data || []).map((lga) => ({
    value: lga.name,
    label: lga.name,
    id: lga.id || lga._id,
    deliveryFee: lga.deliveryFee,
    nextDayDeliveryFee: lga.nextDayDeliveryFee,
    isFreeDelivery: lga.isFreeDelivery,
    deliveryDays: lga.deliveryDays,
    deliveryDates: lga.deliveryDates,
    lastDeliveryDate: lga.lastDeliveryDate,
  }));
};
